import { ImagesVideosTabHeader } from "../controls/ImagesVideosTabHeader";
import { StockAssetsSearch } from "./StockAssetsSearch";
import { useTranslate } from "@refinedev/core";
import { MediaAssetTabs, MediaKind } from "../../../../types";

export const StockAssets = ({
  assetLibraryId,
  previewWidth,
  previewHeight,
  mediaAsset,
  customAddToCanvas,
  onReplaceSelectedAsset,
  selectionMode,
}: {
  assetLibraryId: string;
  previewWidth: number;
  previewHeight: number;
  mediaAsset: MediaAssetTabs;
  customAddToCanvas?: (assetId: string, path: string) => void;
  onReplaceSelectedAsset?: (
    assetId: string,
    path: string,
    mediaType: MediaKind
  ) => void;
  selectionMode?: boolean;
}) => {
  const t = useTranslate();

  const isImagesTab = mediaAsset === MediaAssetTabs.Images;
  return (
    <>
      <ImagesVideosTabHeader
        title={
          isImagesTab
            ? t("components.templates.settings.imagesVideosTab.imageBank")
            : t("components.templates.settings.imagesVideosTab.videoBank")
        }
      />
      <StockAssetsSearch
        currentAssetLibraryId={assetLibraryId}
        assetType={isImagesTab ? "stock_photos" : "stock_videos"}
        previewWidth={previewWidth}
        previewHeight={previewHeight}
        customAddToCanvas={customAddToCanvas}
        onReplaceSelectedAsset={onReplaceSelectedAsset}
        selectionMode={selectionMode}
      />
    </>
  );
};
